import React, { useRef, useState, useEffect } from 'react';
import { connect } from "react-redux";
import { Link, useLocation } from "react-router-dom";

import * as NavigationActions from '../navigation/actions';

import classnames from 'classnames';
import tkggbsLogoVert from './tkggbs-logo-vert.svg';
import tkggbsLogoHoriz from './tkggbs-logo-horiz.svg';
import thkggbsLogin from '../icons/StrokeLogin';
import thkggbsSignup from '../icons/StrokeSignup';

//import '../css/NavBar.css';

// Note that I have replaced "<a href=" to "<Link" in this source and selected-actions.js.  If some problem occures, I should restore the original statement.
const NavLink = ({
  dispatch,
  to,
  icon,
  children
}) => {
  const Svg = icon;
  const pathname = useLocation().pathname;
  const active = pathname === to;
  const anchorClass = classnames({
        'bg-white-10 navbar-item-active': active,
      }, ['dib db-l white no-underline f7 hover-bg-white-10 tc bw2 bw0-l b--navy']);
  const svgClass = classnames({
    'o-100': active,
    'o-50': !active
      }, ['mt2 fill-current-color']);

  return (
    <Link to={to} className={anchorClass} role='menuitem' title={children}>
      <div className='db pb2 ph3'>
        <div className='db'>
          <Svg width='46' role='presentation' className={svgClass} />
        </div>
        <div className={`${active ? 'o-100' : 'o-50'} f7 tc montserrat ttu fw1 `} style={{ whiteSpace: 'pre-wrap' }}>
          {children}
        </div>
      </div>
    </Link>
  );
}

const NavBar = ({
  dispatch,
  pathname
}) => {
  const [ dimention, setDimention ] = useState({
    fullWidth: window.innerWidth,
    fullHeight: window.innerHeight });

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, []);

  const handleResize = () => {
    setDimention({
      fullWidth: window.innerWidth,
      fullHeight: window.innerHeight
    });
  }

  return (
    <div className='z-4 w-100 flex justify-between overflow-x-hidden'>
      <div className='flex'>
        <Link to='/welcome' role='menuitem' title='Welcome page'>
          <img className='pt3 pl3 z-4' style={{ height: 60 }} src={tkggbsLogoHoriz} />
        </Link>
      </div>
      <div className='flex db overflow-x-hidden overflow-y-hidden'>
        <PrivateNavLink to='/login' icon={thkggbsLogin} pathname={pathname}>Login</PrivateNavLink>
        <PrivateNavLink to='/signup' icon={thkggbsSignup} pathname={pathname}>Signup</PrivateNavLink>
      </div>
    </div>
)
}

const mapStateToProps = state => ({
})

const PrivateNavLink = connect(mapStateToProps)(NavLink);
export default connect(mapStateToProps)(NavBar);
